import { customColors } from '../utilities';
import styles from './Header.module.scss';
import TextWithIcon from './typography/TextWithIcon';
import Button from './Button';
import OpenClosedMenu from '../pages/action_items/OpenClosedMenu';

export default function Header({
  title,
  icon,
  backgroundColor,
  size,
  selected = 'Open',
  setSelected,
  showButton,
  showMenu,
  darkMode = true,
  onClick = () => {},
  buttonText = 'Add',
  rightText = null,
}) {
  return (
    <div>
      <div
        className={styles.container}
        style={{
          backgroundColor:
            backgroundColor || darkMode
              ? customColors.DARK_GRAY
              : customColors.DARK_GRAY_TRANSLUCENT,
        }}
      >
        <TextWithIcon
          color={!darkMode ? 'primary' : 'white'}
          weight="semiBold"
          icon={icon}
          size={size || 'md-lg'}
          noMargin
        >
          {title}
        </TextWithIcon>
        {!!rightText && (
          <TextWithIcon
            color={!darkMode ? 'primary' : 'white'}
            weight="semiBold"
            noMargin
          >
            {rightText}
          </TextWithIcon>
        )}
        {!!showButton ? (
          <Button
            value={buttonText}
            icon="add"
            size="sm"
            onClick={onClick}
            className={styles.border}
          />
        ) : null}
      </div>

      {!!showMenu ? (
        <div className={styles.menu}>
          <OpenClosedMenu
            selected={selected}
            setSelected={setSelected}
            size="md"
          />
        </div>
      ) : null}
    </div>
  );
}
